import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings";
import { GenericHttpService } from "../../../../services/generic-http.service";
import { Observable } from "rxjs";
const month = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
@Injectable()
export class InwardEndToEndSlaTrendService {
  apiUrl = environment.gateWayHost;
  editItem: any;
  constructor(public generic: GenericHttpService) {}

  getTransferEndToEndSlaTrendData(url, params): Observable<any> {
    const option = {
      method: "GET",
      url: `${this.apiUrl}${url}`, // "./assets/data/p-d-otiftrends.json",
      query: params
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.processTransferEndToEndSlaTrend)
    );
  }
  processTransferEndToEndSlaTrend(data: any) {
    const percentage = [],
      volume = [];
    const labels = data.data.map(value => {
      if (value.date !== "None") {
        const aDate = new Date(value.date);
        percentage.push(Number(value.percentage.toFixed(2)));
        volume.push(value.volume);
        return `${aDate.getDate()} ${month[aDate.getMonth()]}`;
      }
    });

    return { labels, percentage, volume };
  }

  createChart(chartData, Options) {
    const chart = JSON.parse(JSON.stringify(HSET.chartData));
    chart.xAxis[0].categories = chartData.labels;
    chart.series[0].data = chartData.percentage;
    chart.series[0].name = "SLA";
    chart.series[1].data = chartData.volume;
    chart.series[1].name = "Quantity";
    chart.yAxis[0].title.text = Options.yaxisleft;
    chart.yAxis[1].title.text = Options.yaxisright;
    return chart;
  }
}
